import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.scrollHandler = () => {
      if (window.scrollY > 50) {
        this.element.classList.add("header--shrink")
      } else {
        this.element.classList.remove("header--shrink")
      }
    }
    window.addEventListener("scroll", this.scrollHandler, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.scrollHandler)
  }
}
